export const CUSTOM_META_FIELDS_CHANGED_EVENT = 'customMetaFieldsChanged';

export const notifyCustomMetaFieldsChanged = ownerType => {
    window.dispatchEvent(new CustomEvent(CUSTOM_META_FIELDS_CHANGED_EVENT, {
        detail: {ownerType},
    }));
};
